import {AuthService} from './auth.service';
import {DictionaryService} from './dictionary.service';
import {LocalizationService} from './localization.service';
import {NavLocalizationFactory} from './nav/localization.factory';
import {NavPartnerFactory} from './nav/partner.factory';
import {NavPasswordPolicyFactory} from './nav/password-policy.factory';
import {NavRootFactory} from './nav/root.factory';
import {NavService} from './nav.service';
import {PartnerService} from './partner.service';
import {PasswordPolicyService} from './password-policy.service';
import {ProductPgService} from './product-pg.service';
import {UserService} from './user.service';
import {FileService} from './file.service';
import {NotificationService} from './notification.service';
import {LoaderService} from '../modules/shared/components/loader/loader.service';
import {DocumentService} from './document.service';
import {ModalService} from './modal.service';
import {CoAcquisitionService} from './co-acquisition.service';
import {BrandsService} from './brands.service';
import {SalesCpiService} from './sales-cpi.service';
import {TranscoderService} from './transcoder.service';
import {TariffElementService} from './tariff-element.service';
import {PolicyService} from './policy.service';
import {AsideService} from './aside.service';
import {AclService} from './acl.service';
import {ProductService} from './product.service';
import {ProductCpiService} from './product-cpi.service';
import {SalesPgService} from './sales-pg.service';
import {AttachmentService} from './attachment.service';
import {ExportXmlService} from './export-xml.service';
import {ReportsService} from './reports.service';
import {MigratedPoliciesService} from './migrated-policies.service';
import {ClaimsService} from './claims.service';
import {RepositoryPoliciesService} from './repository-policies.service';

export const rootService = [
    AclService,
    AsideService,
    AttachmentService,
    AuthService,
    BrandsService,
    ClaimsService,
    CoAcquisitionService,
    RepositoryPoliciesService,
    DictionaryService,
    DocumentService,
    ExportXmlService,
    FileService,
    LoaderService,
    LocalizationService,
    ModalService,
    MigratedPoliciesService,
    NavLocalizationFactory,
    NavPartnerFactory,
    NavPasswordPolicyFactory,
    NavRootFactory,
    NavService,
    NotificationService,
    PartnerService,
    PasswordPolicyService,
    PolicyService,
    ProductCpiService,
    ProductPgService,
    ProductService,
    ReportsService,
    SalesCpiService,
    SalesPgService,
    TariffElementService,
    TranscoderService,
    UserService,
];
